import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleKeywordWhere extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length >= 1 &&
			this.multiValueFilters.length >= 0 &&
			this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHERE) &&
			!this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHAT)
		);
	}

	protected getPageTitle(): string {
		const keywordWhereValue = this.getFilterValue(ParameterType.KEYWORD_WHERE);

		return `${this.titlePortalType} in "${keywordWhereValue}"`;
	}
}
